import { Collapse } from "antd";

interface LengthValidatorInputType {
  value: string;
}

const LengthValidator = ({ value }: LengthValidatorInputType) => {
  if (!value || !value?.trim()) {
    return Promise.resolve();
  }
  const numbersArray = value.split(",").map((number: string) => number.trim());
  const invalidEntries = numbersArray.filter(
    (number: string) => number.length !== 11
  );
  if (invalidEntries.length > 0) {
    return Promise.reject(
      <div className="py-4">
        <Collapse
          className="w-full"
          items={[
            {
              key: "1",
              label: (
                <p className={"text-red-600"}>Numbers must be 11 digits long</p>
              ),
              children: (
                <>
                  {invalidEntries.map((invalidEntry: string, index: number) => {
                    return <p key={index}>{invalidEntry}</p>;
                  })}
                </>
              ),
            },
          ]}
        />
      </div>
    );
  }
  return Promise.resolve();
};

export default LengthValidator;
